import { connect } from 'react-redux';

import map from 'lodash/map';
import concat from 'lodash/concat';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';

import LanguageSelector from './translations_language_selector.jsx';

import { AVAILABLE_LANGUAGE_OPTIONS } from 'translations/available_languages.js';

import {
  getTranslationsIsEnabled,
  getTranslationsAppliedLanguages
} from 'zoomforth_codesbane_viewer/reducers/index.js';


const mapStateToProps = (state, { defaultLanguageIso })=> {
  const isTranslationEnabledForSite = getTranslationsIsEnabled(state);
  const appliedLanguages = getTranslationsAppliedLanguages(state);

  const languageOptions = filter(AVAILABLE_LANGUAGE_OPTIONS, (option)=> {
    const appliedIsos = map(filter(appliedLanguages, ['is_hidden', false]), 'iso');
    const langsToShow = concat([defaultLanguageIso], appliedIsos);
    const foundIdx = findIndex(langsToShow, (o)=> o === option.value);

    return foundIdx >= 0;
  });

  const shouldShowSelector = isTranslationEnabledForSite;

  return { shouldShowSelector, languageOptions };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSelector);
